export default __webpack_public_path__ + "static/6-c6bbb8604a2e4e53fc25e538a104db56.jpg";